import { defineRoute } from '../core/contract';
import { ConfigResZ } from '../schemas/config';

/** Owner: platform (Foundation writes the handler in server core). */

export const getConfig = defineRoute({
  name: 'config.get',
  method: 'GET',
  path: '/api/config',
  auth: 'pub',
  gate: false,
  res: ConfigResZ,
  summary: 'Public runtime config: version, minClient, VAPID key, feature flags.',
});
